import { Component, OnInit } from '@angular/core';
import { UserAuth } from '@nrwl/common-lib';
const thresholdConfig = require('../../json/thresholdConfig.json');
import { find, get } from 'lodash';

@Component({
  selector: 'nrwl-threshold-settings',
  templateUrl: './threshold.settings.component.html',
  styleUrls: ['./threshold.settings.component.scss']
})
export class ThresholdSettingsComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataConfig: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thresholdTabs: Array<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  kpiThresholdConfig: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  historicalThresholdConfig: any;
  tabIndex = 0;
  authorized = false;
  constructor(private readonly userAuth: UserAuth) {}

  ngOnInit() {
    this.dataConfig = thresholdConfig;
    this.authorized = this.userAuth.isAuthedFor('READ_WRITE');
    if (this.dataConfig) {
      this.thresholdTabs = get(this.dataConfig, 'thresholdsTabs');
      this.kpiThresholdConfig = find(this.thresholdTabs, ['id', 'kpi-threshold']);
      this.historicalThresholdConfig = find(this.thresholdTabs, ['id', 'historical-threshold']);
    }
  }

  tabChange(index: number): void {
    this.tabIndex = index;
  }
}
